import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { JobQualificationsService } from '../job-qualifications.service';
import * as jobQualificationActions from '../actions/job-qualifications.actions';
import { ClinicalService } from 'src/app/clinical/clinical.service';

@Injectable()
export class JobQualificationsEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _service: JobQualificationsService,
        private readonly _clinicalService: ClinicalService
    ) {}

    getJobQualifications$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadQualifications),
            switchMap((action) => {
                return this._service.getRequirements(action.jobId).pipe(
                    map((requirements) =>
                        jobQualificationActions.loadQualificationsSuccess({ qualifications: requirements })
                    ),
                    catchError((result) => of(jobQualificationActions.loadQualificationsFailure({ error: result })))
                );
            })
        );
    });

    getJobQualificationChanges$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadQualificationChanges),
            switchMap((action) => {
                return this._service.getChanges(action.jobId).pipe(
                    map((changes) => jobQualificationActions.loadQualificationChangesSuccess({ changes: changes })),
                    catchError((result) =>
                        of(jobQualificationActions.loadQualificationChangesFailure({ error: result }))
                    )
                );
            })
        );
    });

    getAvailableSkills$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadAvailableSkills),
            switchMap((action) => {
                return this._service.getAvailableSkills(action.professionId, action.expertiseId).pipe(
                    map((skills) => jobQualificationActions.loadAvailableSkillsSuccess({ skills: skills })),
                    catchError((result) => of(jobQualificationActions.loadAvailableSkillsFailure({ error: result })))
                );
            })
        );
    });

    getAvailableCerts$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadAvailableCerts),
            switchMap((action) => {
                return this._service.getAvailableCerts(action.professionId, action.expertiseId).pipe(
                    map((certs) => jobQualificationActions.loadAvailableCertsSuccess({ certs: certs })),
                    catchError((result) => of(jobQualificationActions.loadAvailableCertsFailure({ error: result })))
                );
            })
        );
    });

    getClinicalTrackCerts$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadClinicalTrackCerts),
            switchMap((action) => {
                return this._clinicalService.getCertificationsByClinicalTrackId(action.clinicalTrackId).pipe(
                    map((certs) => jobQualificationActions.loadClinicalTrackCertsSuccess({ certs: certs })),
                    catchError((result) => of(jobQualificationActions.loadClinicalTrackCertsFailure({ error: result })))
                );
            })
        );
    });

    getRequirementsFromUD$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.getRequirementsFromUD),
            switchMap((action) => {
                return this._service.getRequirementsFromUD(action.jobId).pipe(
                    map((result) => jobQualificationActions.getRequirementsFromUDSuccess({ qualifications: result })),
                    catchError((result) => of(jobQualificationActions.getRequirementsFromUDFailure({ error: result })))
                );
            })
        );
    });

    getClinicalTrackSkills$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadClinicalTrackSkills),
            switchMap((action) => {
                return this._clinicalService.getSkillsByClinicalTrackId(action.clinicalTrackId).pipe(
                    map((skills) => {
                        return jobQualificationActions.loadClinicalTrackSkillsSuccess({ skills: skills });
                    }),
                    catchError((result) =>
                        of(jobQualificationActions.loadClinicalTrackSkillsFailure({ error: result }))
                    )
                );
            })
        );
    });
}
